import React from 'react';
import { 
  Box, 
  Typography, 
  Card, 
  Grid,
  List,
  ListItemIcon,
  ListItemText,
  ListItemButton,
  Divider,
  Link,
  IconButton
} from '@mui/material';
import { useNavigate } from 'react-router-dom';
import {
  Description,
  ArrowBack,
  Security,
  CloudUpload
} from '@mui/icons-material';

const ResourceLink = ({ icon, primary, secondary, href, external }) => (
  <ListItemButton 
    component={Link}
    href={href}
    target={external ? "_blank" : "_self"}
    rel={external ? "noopener noreferrer" : ""}
    sx={{ 
      py: 1.5,
      px: 2,
      color: '#2e2e2e',
      textDecoration: 'none',
      '&:hover': {
        backgroundColor: 'rgba(53, 152, 183, 0.08)',
      }
    }}
  >
    <ListItemIcon sx={{ color: '#3598b7', minWidth: 40 }}>
      {icon}
    </ListItemIcon>
    <ListItemText 
      primary={primary}
      secondary={secondary}
      primaryTypographyProps={{
        sx: { color: 'inherit', fontWeight: 500 }
      }}
      secondaryTypographyProps={{
        sx: { color: 'rgba(46, 46, 46, 0.7)' }
      }}
    />
  </ListItemButton>
);



const PostFlight = () => {
  const navigate = useNavigate();

  const postFlightLinks = [
    // {
    //   icon: <Description />,
    //   primary: "Mission Form Control (MFC)",
    //   secondary: "Fullfør MFC etter flyging",
    //   href: "https://form.jotform.com/213212604878354",
    //   external: true
    // },
    {
      icon: <CloudUpload />,
      primary: "Dronelogbook",
      secondary: "Oppdater mission status og last opp data",
      href: "https://www.dronelogbook.com",
      external: true
    },
    // {
    //   icon: <Security />,
    //   primary: "Job Safety Analysis (JSA)",
    //   secondary: "Gjennomfør etterflygingsvurdering",
    //   href: "https://form.jotform.com/213192990452357",
    //   external: true
    // }
  ];



  return (
    <Box sx={{ 
      p: 3, 
      maxWidth: 1200, 
      margin: '0 auto',
      minHeight: '100vh'
    }}>
      <Box sx={{ mb: 3 }}>
        <Typography variant="h5" sx={{ color: '#2e2e2e', fontWeight: 600, mb: 1 }}>
          Pilot Ressurser
        </Typography>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <IconButton 
            onClick={() => navigate('/pilot')}
            sx={{ mr: 2 }}
          >
            <ArrowBack />
          </IconButton>
          <Typography variant="h4" sx={{ color: '#3598b7', fontWeight: 600 }}>
            Etter Flyging & Feilsøking
          </Typography>
        </Box>
      </Box>

      <Grid container spacing={3}>
        <Grid item xs={12} md={6}>
          <Card sx={{ 
            backgroundColor: '#ffffff', 
            borderRadius: 0,
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
              <Typography variant="h6" sx={{ color: '#3598b7', fontWeight: 600 }}>
                Etterflygingsskjemaer
              </Typography>
            </Box>
            <List disablePadding sx={{ flex: 1 }}>
              {postFlightLinks.map((form, index) => (
                <React.Fragment key={index}>
                  <ResourceLink {...form} />
                  {index < postFlightLinks.length - 1 && <Divider />}
                </React.Fragment>
              ))}
            </List>
          </Card>
        </Grid>

        <Grid item xs={12}>
          <Card sx={{ 
            backgroundColor: '#ffffff', 
            borderRadius: 0,
            boxShadow: 'none',
            border: '1px solid rgba(0, 0, 0, 0.12)',
            display: 'flex',
            flexDirection: 'column'
          }}>
            <Box sx={{ p: 2, borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
              <Typography variant="h6" sx={{ color: '#3598b7', fontWeight: 600 }}>
                Merk
              </Typography>
            </Box>
            <Box sx={{ p: 2 }}>
              <Typography variant="body1" sx={{ color: 'rgba(0, 0, 0, 0.7)' }}>
                Denne siden er ikke ferdig utviklet ennå. Flere funksjoner kommer etter behov.
              </Typography>
            </Box>
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PostFlight;
